<!-- <div class="container ml-2">
    <mat-form-field class="example-full-width">
        <mat-label>Area</mat-label>
        <input matInput placeholder="Cerca..." [(ngModel)]="query">
    </mat-form-field>
    
    

</div> -->
<div style="margin-top: 80px;">
    <form class="container">
        <mat-form-field class="example-full-width">
            <mat-label>Area</mat-label>
            <input matInput placeholder="Cerca..." [(ngModel)]="query" name="query">
        </mat-form-field>
        <button type="submit" mat-stroked-button class="ml-2" (click)="searchArea()">Trova</button>
        <mat-spinner diameter="35" *ngIf="loading" id="loading-spinner"></mat-spinner>
    </form>
    <!-- <app-detail-map-v2 [aree]="foundArea"></app-detail-map-v2> -->
    <div class="container" id="itemList-container">
        <span *ngFor="let feature of this.featureCollection.features" class="item-span" (click)="onItemClick(feature)">
            {{ feature.properties.display_name }} </span>
    </div>
    <div class="container" id="map-container">
        <agm-map #AgmMap style="width: 100%; height: 100%;" (mapReady)="onMapReady($event)" [zoomControl]="true"
            [scrollwheel]="false" [streetViewControl]="false">
            <agm-data-layer [geoJson]="selectedAreaGeoJson" [style]="styleFunc"></agm-data-layer>
        </agm-map>
    </div>
</div>